var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("InScan RVP Shipments")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.formLoading
    },
    on: {
      "update:active": function($event) {
        _vm.formLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm('form-1')
      },
      "reset": _vm.reset
    }
  }, [_c('div', {
    staticClass: "form group-row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Packaging Type: ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.weightType')
    },
    attrs: {
      "options": _vm.weightTypeOptions,
      "selected-option": _vm.selectedWeight,
      "placeholder": "--Not Mandatory--",
      "name": "weightType"
    },
    on: {
      "select": _vm.SelectWeight
    },
    model: {
      value: (_vm.weightType),
      callback: function($$v) {
        _vm.weightType = $$v
      },
      expression: "weightType"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openDimentionWeightTab),
      expression: "openDimentionWeightTab"
    }],
    staticClass: "form group-row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Lenght(cm):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-alt'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Length')
    },
    attrs: {
      "type": "text",
      "id": "lengthid",
      "placeholder": "Enter Length",
      "name": "Length"
    },
    model: {
      value: (_vm.length),
      callback: function($$v) {
        _vm.length = $$v
      },
      expression: "length"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Length')),
      expression: "errors.has('form-1.Length')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Length')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Breadth(cm):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-h'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Breadth')
    },
    attrs: {
      "type": "text",
      "id": "breadthid",
      "placeholder": "Enter Breadth",
      "name": "Breadth"
    },
    model: {
      value: (_vm.breadth),
      callback: function($$v) {
        _vm.breadth = $$v
      },
      expression: "breadth"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Breadth')),
      expression: "errors.has('form-1.Breadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Breadth')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Height(cm):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-v'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Height')
    },
    attrs: {
      "type": "text",
      "id": "heightid",
      "placeholder": "Enter Height",
      "name": "Height"
    },
    model: {
      value: (_vm.height),
      callback: function($$v) {
        _vm.height = $$v
      },
      expression: "height"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Height')),
      expression: "errors.has('form-1.Height')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Height')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Physical Weight(kg):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Physical_Weight')
    },
    attrs: {
      "type": "text",
      "id": "physicalWeightId",
      "placeholder": "Enter Physical Weight",
      "maxlength": 6,
      "name": "Physical_Weight"
    },
    on: {
      "keyup": _vm.checkPW
    },
    model: {
      value: (_vm.physicalWeight),
      callback: function($$v) {
        _vm.physicalWeight = $$v
      },
      expression: "physicalWeight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Physical_Weight')),
      expression: "errors.has('form-1.Physical_Weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Physical_Weight')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPWcheckBox),
      expression: "showPWcheckBox"
    }],
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmPhyWt),
      expression: "isConfirmPhyWt"
    }],
    staticClass: "status mr-2 checkboxLarge status-radio",
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isConfirmPhyWt",
      "id": "isConfirmPhyWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmPhyWt) ? _vm._i(_vm.isConfirmPhyWt, "") > -1 : (_vm.isConfirmPhyWt)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isConfirmPhyWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmPhyWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmPhyWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmPhyWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_vm._v("Confirm Physical Weight:")])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVWcheckBox),
      expression: "showVWcheckBox"
    }],
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmVolWt),
      expression: "isConfirmVolWt"
    }],
    staticClass: "status mr-2 checkboxLarge status-radio",
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isConfirmVolWt",
      "id": "isConfirmVolWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmVolWt) ? _vm._i(_vm.isConfirmVolWt, "") > -1 : (_vm.isConfirmVolWt)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isConfirmVolWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmVolWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmVolWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmVolWt = $$c
        }
      }
    }
  }), _vm._v(" Confirm Volumetric Weight:\n                      ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form group-row"
  }, [(_vm.isShipInputBoxShown) ? _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.isManualEntryRestrict) ? _c('b-form-fieldset', [_c('label', [_vm._v("Scan Shipment Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader,
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentBarcode),
      expression: "shipmentBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearShipmentBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shipmentBarcode')
    },
    attrs: {
      "type": "text",
      "id": "clearShipmentBarcode",
      "placeholder": "Scan Shipment Barcode",
      "name": "shipmentBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentBarcode)
    },
    on: {
      "keypress": _vm.changeTabPosition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shipmentBarcode')),
      expression: "errors.has('form-1.shipmentBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.shipmentBarcode')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isManualEntryRestrict) ? _c('b-form-fieldset', [_c('label', [_vm._v("Scan Shipment barcode :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader,
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentBarcode),
      expression: "shipmentBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearShipmentBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shipmentBarcode')
    },
    attrs: {
      "type": "text",
      "id": "clearShipmentBarcode",
      "placeholder": "Scan Shipment Barcode",
      "name": "shipmentBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentBarcode)
    },
    on: {
      "keydown": _vm.detectKeyPressForShipment,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentBarcode = $event.target.value
      }
    }
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.isManualEntryRestrict) ? _c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearFlyerBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.flyerBarcode')
    },
    attrs: {
      "type": "text",
      "id": "clearFlyerBarcode",
      "placeholder": "Scan Flyer Barcode",
      "name": "flyerBarcode",
      "autocomplete": "off"
    },
    on: {
      "change": function($event) {
        return _vm.checkTLQCStatus(_vm.shipmentBarcode, _vm.flyerBarcode)
      }
    },
    model: {
      value: (_vm.flyerBarcode),
      callback: function($$v) {
        _vm.flyerBarcode = $$v
      },
      expression: "flyerBarcode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.flyerBarcode')),
      expression: "errors.has('form-1.flyerBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.flyerBarcode')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isManualEntryRestrict) ? _c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyerBarcode),
      expression: "flyerBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearFlyerBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.flyerBarcode')
    },
    attrs: {
      "type": "text",
      "id": "clearFlyerBarcode",
      "placeholder": "Scan Flyer Barcode",
      "name": "flyerBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.flyerBarcode)
    },
    on: {
      "keydown": _vm.detectKeyPressForFlyer,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyerBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.flyerBarcode')),
      expression: "errors.has('form-1.flyerBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.flyerBarcode')))])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "disabled": (_vm.IsPrinterAvailable && !(_vm.flyerBarcode && _vm.shipmentBarcode)) || (!_vm.IsPrinterAvailable && (!_vm.flyerBarcode)) || _vm.inscanBtnDisabled
    }
  }, [_vm._v(" Inscan")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetAll
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "enlarge-css"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.openModelPendingShipmentList(_vm.modalType)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "RVP Pending For InScan",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('RVP')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentLoading,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "width": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('RVP')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload RVP InScan Shipments"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.total) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_id')
    },
    attrs: {
      "type": "text",
      "id": "clearSearchField",
      "placeholder": "Search By Shipping id",
      "name": "Shipping_id"
    },
    model: {
      value: (_vm.searchByShippingId),
      callback: function($$v) {
        _vm.searchByShippingId = $$v
      },
      expression: "searchByShippingId"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getPendingShipmentListForPickupDone
    }
  }, [_vm._v(" Search")])])], 1)], 1)])]), _vm._v(" "), _c('pending-InscanRVP', {
    attrs: {
      "rvpInscanPendingShipments": _vm.pendingShipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending For Return (RVP)",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('Shortage')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentLoading,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "width": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('Shortage')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalShipments) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_ID')
    },
    attrs: {
      "type": "text",
      "id": "clearShortageSearchField",
      "placeholder": "Search By Shipping id",
      "name": "Shipping_ID"
    },
    model: {
      value: (_vm.searchByShippingIdForShortage),
      callback: function($$v) {
        _vm.searchByShippingIdForShortage = $$v
      },
      expression: "searchByShippingIdForShortage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getShortageShipmentList
    }
  }, [_vm._v(" Search")])])], 1)], 1)])]), _vm._v(" "), _c('shortage-shipments', {
    attrs: {
      "shortagePendingShipments": _vm.shortageShipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShortagePaginate),
      expression: "showShortagePaginate"
    }],
    attrs: {
      "page-count": _vm.pageCountForShortage,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataForShortage,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "RVP Pending For InScan"
    },
    model: {
      value: (_vm.pendingShipmentModel),
      callback: function($$v) {
        _vm.pendingShipmentModel = $$v
      },
      expression: "pendingShipmentModel"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentLoadingMdl,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentLoadingMdl = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RVP Pending For InScan")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('RVPMdl')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row mb-2 justify-content-end"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "margin-top": "0.2em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    on: {
      "click": function($event) {
        return _vm.refresh('RVPModal')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "1em",
      "margin-top": "0.2em"
    }
  }, [_vm._v("Count : " + _vm._s(_vm.total3))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_Id')
    },
    attrs: {
      "type": "text",
      "id": "clearSearchFieldMdl",
      "placeholder": "Search By Shipping id",
      "name": "Shipping_Id"
    },
    model: {
      value: (_vm.searchByShippingIdMdl),
      callback: function($$v) {
        _vm.searchByShippingIdMdl = $$v
      },
      expression: "searchByShippingIdMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getShipmentbyShippingIdMdl
    }
  }, [_vm._v(" Search")])])], 1)], 1)]), _vm._v(" "), _c('pending-InscanRVP', {
    attrs: {
      "rvpInscanPendingShipments": _vm.pendingShipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('RVPMdl')
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Shortage Shipment List"
    },
    model: {
      value: (_vm.shortageShipmentMdl),
      callback: function($$v) {
        _vm.shortageShipmentMdl = $$v
      },
      expression: "shortageShipmentMdl"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isShortageShipmentLoadingMdl,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isShortageShipmentLoadingMdl = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "document"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending For Return (RVP)")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "name": "button",
      "data-dismiss": "modal",
      "area-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('ShortageMdl')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row mb-2 justify-content-end"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "margin-top": "0.2em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    on: {
      "click": function($event) {
        return _vm.refresh('SSMdl')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "1em",
      "margin-top": "0.2em"
    }
  }, [_vm._v("Count : " + _vm._s(_vm.totalShortageShipMDl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ShortageShippingMdl",
      "placeholder": "Enter Shipping Id",
      "name": "shortageShippingMdl"
    },
    model: {
      value: (_vm.shortageShippingIdMdl),
      callback: function($$v) {
        _vm.shortageShippingIdMdl = $$v
      },
      expression: "shortageShippingIdMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getShortageShipmentListMdl
    }
  }, [_vm._v(" Search")])])], 1)], 1)]), _vm._v(" "), _c('shortage-shipments', {
    attrs: {
      "shortagePendingShipments": _vm.shortageShipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShortagePaginateMdl),
      expression: "showShortagePaginateMdl"
    }],
    attrs: {
      "page-count": _vm.pageCountForShortageMdl,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getShortagePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('ShortageMdl')
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Process QC Check"
    },
    model: {
      value: (_vm.checkTLQCProcessModal),
      callback: function($$v) {
        _vm.checkTLQCProcessModal = $$v
      },
      expression: "checkTLQCProcessModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Process QC Check")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModel
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card qcCheckPanel"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RVPShipment),
      expression: "RVPShipment"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('RVPShipment')
    },
    attrs: {
      "id": "RVPShipment",
      "type": "text",
      "name": "RVPShipment",
      "placeholder": "Scan RVP Shipment",
      "disabled": _vm.SetReadonlyMode
    },
    domProps: {
      "value": (_vm.RVPShipment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RVPShipment = $event.target.value
      }
    }
  })])], 1), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.NewRES.length > 0) ? _c('form-wizard', {
    attrs: {
      "start-index": _vm.stepIndex,
      "title": null,
      "subtitle": null,
      "color": _vm.themecolor,
      "stepSize": "xs",
      "finishButtonText": "Submit QC",
      "backButtonText": "Prev QC",
      "nextButtonText": "Next QC"
    },
    on: {
      "update:startIndex": function($event) {
        _vm.stepIndex = $event
      },
      "update:start-index": function($event) {
        _vm.stepIndex = $event
      },
      "on-complete": _vm.sumbitQCFormDetails
    }
  }, _vm._l((_vm.NewRES), function(Tab, tabIndex) {
    return _c('tab-content', {
      key: tabIndex,
      attrs: {
        "title": Tab.ProductID,
        "before-change": _vm.validateFormData
      }
    }, [_c('form', {
      attrs: {
        "data-vv-scope": 'formw_' + tabIndex
      },
      on: {
        "reset": _vm.reset
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('vue-element-loading', {
      attrs: {
        "spinner": "line-scale",
        "color": "#FF6700",
        "active": _vm.isLoadingGetQuestions,
        "text": "Please wait"
      },
      on: {
        "update:active": function($event) {
          _vm.isLoadingGetQuestions = $event
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "margin-top": "30px",
        "margin-inline": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-top": "50px",
        "margin-inline": "10px"
      }
    }, [_vm._v(" Images Shared by Client :")]), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('tr', _vm._l((Tab.ClientPickupProductImages), function(item, index) {
      return _c('td', {
        staticStyle: {
          "margin-left": "10px"
        }
      }, [_c('a', {
        attrs: {
          "href": item.ImageUrl,
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "20%",
          "height": "50px"
        },
        attrs: {
          "src": item.ImageUrl,
          "alt": ""
        }
      })])])
    }), 0)]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-top": "50px",
        "margin-inline": "10px"
      }
    }, [_vm._v(" Images Clicked by SR :")]), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('tr', _vm._l((Tab.SRPickDoneImages), function(item, index) {
      return _c('td', {
        key: index,
        staticStyle: {
          "margin-left": "10px"
        }
      }, [_c('a', {
        attrs: {
          "href": item.ImageUrl,
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100%",
          "height": "50px"
        },
        attrs: {
          "src": item.ImageUrl,
          "alt": ""
        }
      })])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_vm._l((Tab.QCParameters), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "col-md-12",
        staticStyle: {
          "margin-top": "30px",
          "margin-inline": "10px"
        }
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('div', {
        staticClass: "col-md-6"
      }, [_c('label', [_vm._v(_vm._s(item.Label))])]), _vm._v(" "), (item.Type.toLowerCase() === 'boolean') ? _c('b-input-group', {
        staticClass: "col-md-6"
      }, [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Tab.QCParameters[index][_vm.Answer[index]]),
          expression: "Tab.QCParameters[index][Answer[index]]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "type": "radio",
          "id": "Yes1",
          "value": "Yes",
          "name": 'BooleanAnswer_' + index + '_' + Tab.ProductID
        },
        domProps: {
          "checked": _vm._q(Tab.QCParameters[index][_vm.Answer[index]], "Yes")
        },
        on: {
          "click": function($event) {
            return _vm.AnsYes(item.Label, Tab.ProductID)
          },
          "change": function($event) {
            return _vm.$set(Tab.QCParameters[index], _vm.Answer[index], "Yes")
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Yes")])]), _vm._v("      \n                                  "), _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Tab.QCParameters[index][_vm.Answer[index]]),
          expression: "Tab.QCParameters[index][Answer[index]]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "type": "radio",
          "id": "No1",
          "value": "No",
          "name": 'BooleanAnswer_' + index + '_' + Tab.ProductID
        },
        domProps: {
          "checked": _vm._q(Tab.QCParameters[index][_vm.Answer[index]], "No")
        },
        on: {
          "click": function($event) {
            return _vm.AnsNo(item.Label, Tab.ProductID)
          },
          "change": function($event) {
            return _vm.$set(Tab.QCParameters[index], _vm.Answer[index], "No")
          }
        }
      }), _c('label', [_vm._v("No")])]), _vm._v(" "), _c('span', {
        staticClass: "text-danger ml-4",
        attrs: {
          "v-show": _vm.errors.has('formw_' + tabIndex + '.BooleanAnswer_' + index + '_' + Tab.ProductID)
        }
      }, [_vm._v(" " + _vm._s(_vm.errors.first('formw_' + tabIndex + '.BooleanAnswer_' + index + '_' + Tab.ProductID)) + "  ")])]) : _vm._e(), _vm._v(" "), (item.Type.toLowerCase().trim() == 'text') ? _c('b-input-group', {
        staticClass: "col-md-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Tab.QCParameters[index][_vm.Answer[index]]),
          expression: "Tab.QCParameters[index][Answer[index]]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": 'TextAnswer_' + index + '_' + Tab.ProductID,
          "type": "text",
          "placeholder": "Please enter"
        },
        domProps: {
          "value": (Tab.QCParameters[index][_vm.Answer[index]])
        },
        on: {
          "change": function($event) {
            return _vm.AnsText(Tab.QCParameters[index][_vm.Answer[index]], item.Label, Tab.ProductID)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Tab.QCParameters[index], _vm.Answer[index], $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text-danger ml-4",
        attrs: {
          "v-show": _vm.errors.has('formw_' + tabIndex + '.TextAnswer_' + index)
        }
      }, [_vm._v(" " + _vm._s(_vm.errors.first('formw_' + tabIndex + '.TextAnswer_' + index + '_' + Tab.ProductID)) + " ")])]) : _vm._e(), _vm._v(" "), (item.Type.toLowerCase().trim() == 'number') ? _c('b-input-group', {
        staticClass: "col-md-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Tab.QCParameters[index][_vm.Answer[index]]),
          expression: "Tab.QCParameters[index][Answer[index]]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": 'TextNumberAnswer_' + index + '_' + Tab.ProductID,
          "type": "number",
          "placeholder": "Please enter"
        },
        domProps: {
          "value": (Tab.QCParameters[index][_vm.Answer[index]])
        },
        on: {
          "change": function($event) {
            return _vm.AnsNumber(Tab.QCParameters[index][_vm.Answer[index]], item.Label, Tab.ProductID)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Tab.QCParameters[index], _vm.Answer[index], $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text-danger ml-4",
        attrs: {
          "v-show": _vm.errors.has('formw_' + tabIndex + '.TextNumberAnswer_' + index)
        }
      }, [_vm._v(" " + _vm._s(_vm.errors.first('formw_' + tabIndex + '.TextNumberAnswer_' + index + '_' + Tab.ProductID)) + " ")])]) : _vm._e(), _vm._v(" "), (item.Type.toLowerCase().trim() == 'numeric') ? _c('b-input-group', {
        staticClass: "col-md-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Tab.QCParameters[index][_vm.Answer[index]]),
          expression: "Tab.QCParameters[index][Answer[index]]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": 'TextNumericAnswer_' + index + '_' + Tab.ProductID,
          "type": "number",
          "placeholder": "Please enter"
        },
        domProps: {
          "value": (Tab.QCParameters[index][_vm.Answer[index]])
        },
        on: {
          "change": function($event) {
            return _vm.AnsNumber(Tab.QCParameters[index][_vm.Answer[index]], item.Label, Tab.ProductID)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Tab.QCParameters[index], _vm.Answer[index], $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text-danger ml-4",
        attrs: {
          "v-show": _vm.errors.has('formw_' + tabIndex + '.TextNumericAnswer_' + index)
        }
      }, [_vm._v(" " + _vm._s(_vm.errors.first('formw_' + tabIndex + '.TextNumericAnswer_' + index + '_' + Tab.ProductID)) + " ")])]) : _vm._e()], 1), _c('br')])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-fieldset', [_c('form', {
      attrs: {
        "action": "#",
        "method": "POST",
        "enctype": "multipart/form-data"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.UploadedImgCount < 4),
        expression: "UploadedImgCount < 4"
      }],
      staticClass: "file-upload col-md-12"
    }, [_c('label', {
      attrs: {
        "for": "uploadImage1"
      }
    }, [_c('i', {
      staticClass: "fa fa-upload",
      attrs: {
        "title": "Upload Image",
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', [_vm._v(" Click to Upload Multiple Images")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('input', {
      ref: "uploadImage1",
      refInFor: true,
      attrs: {
        "id": "uploadImage1",
        "name": "uploadImage1",
        "accept": ".jpeg,.png,.jpg",
        "type": "file",
        "multiple": "multiple"
      },
      on: {
        "change": _vm.handleFileUpload
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.UploadedImgCount < 4),
        expression: "UploadedImgCount < 4"
      }],
      staticClass: "clientnote col-md-12"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" Note: Allowed File Format JPG,JPEG,PNG."), _c('br'), _vm._v(" "), _c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" Note: File Size Allowed Up to 5MB.\n                                        ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('uploadImage1')),
        expression: "errors.has('uploadImage1')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please upload image file.")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [(_vm.UploadedImageArr.length > 0) ? _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('span', [_vm._v(" Uploaded Images :")]), _vm._v(" "), _c('vue-element-loading', {
      attrs: {
        "spinner": "line-scale",
        "color": "#FF6700",
        "active": _vm.isLoadingupload,
        "text": "Please wait"
      },
      on: {
        "update:active": function($event) {
          _vm.isLoadingupload = $event
        }
      }
    }), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('tr', _vm._l((_vm.UploadedImageArr), function(item, index) {
      return _c('td', {
        staticClass: "parent"
      }, [_c('button', {
        staticClass: "close",
        attrs: {
          "type": "button",
          "aria-label": "Close"
        },
        on: {
          "click": function($event) {
            return _vm.RemoveImage(item, index, Tab.ProductID)
          }
        }
      }, [_vm._v("x")]), _vm._v(" "), _c('img', {
        staticStyle: {
          "width": "100%",
          "height": "50px"
        },
        attrs: {
          "src": item.ImageUrl,
          "alt": ""
        }
      })])
    }), 0)])], 1) : _vm._e()])])])])], 1)], 2)], 1)])])
  }), 1) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "data-toggle": "modal"
    },
    model: {
      value: (_vm.uploadMultipleImageModal),
      callback: function($$v) {
        _vm.uploadMultipleImageModal = $$v
      },
      expression: "uploadMultipleImageModal"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Day End Closure - Upload Image\n                  "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeuploadMultipleImageModal
    }
  }, [_vm._v("×")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Process QC Check"
    },
    model: {
      value: (_vm.restrictTLQCModal),
      callback: function($$v) {
        _vm.restrictTLQCModal = $$v
      },
      expression: "restrictTLQCModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("TLQC Restrict")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelRestrict
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card qcCheckPanel"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("\n                      " + _vm._s(_vm.restrictTLQCError))])]), _c('br')])])])])])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11cb5b1a","hasScoped":false}!./src/views/components/InScanRVPShipments/InScanRVPShipments.html
// module id = 1324
// module chunks = 1